export default __webpack_public_path__ + "static/media/metalwall3.ed8ee8ce.png";